module.exports = "<div class=\"modal__dialog {{size ? 'modal-' + size : ''}}\">\n    <div uib-modal-transclude></div>\n</div>";